import httpClient from '@/shared/lib/httpClient';
import { Agent, Session, SessionCreateRequest, SessionUpdateRequest, SessionDetail, SessionListResponse, SessionDeleteResponse } from '@/shared/types/session';

// Sessões
export async function createSession(data: SessionCreateRequest): Promise<Session> {
    return httpClient.post<Session>('/sessions', data);
}

export async function getUserSessions(): Promise<SessionListResponse> {
    return httpClient.get<SessionListResponse>('/sessions');
}

export async function findProjectIdBySessionId(sessionId: string): Promise<string | undefined> {
    const response = await getUserSessions();
    const matchedSession = response.sessions.find((session) => session.id === sessionId);
    return matchedSession?.project_id;
}

export async function getDefaultProjectIdFromSessions(): Promise<string | undefined> {
    const response = await getUserSessions();
    return response.sessions[0]?.project_id;
}

export async function getProjectSessions(projectId: string): Promise<Session[]> {
    const response = await httpClient.get<{ sessions?: Session[] } | Session[]>(`/projects/${projectId}/sessions`);
    if (Array.isArray(response)) {
        return response;
    }
    return response.sessions || [];
}

export async function getSessionDetail(projectId: string, sessionId: string): Promise<SessionDetail> {
    return httpClient.get<SessionDetail>(`/projects/${projectId}/sessions/${sessionId}`);
}

export async function updateSession(projectId: string, sessionId: string, data: SessionUpdateRequest): Promise<Session> {
    return httpClient.put<Session>(`/projects/${projectId}/sessions/${sessionId}`, data);
}

export async function updateSessionStatus(projectId: string, sessionId: string, status: string): Promise<{ success: boolean; message: string }> {
    return httpClient.put<{ success: boolean; message: string }>(`/projects/${projectId}/sessions/${sessionId}/status`, { status });
}

export async function deleteSession(projectId: string, sessionId: string): Promise<SessionDeleteResponse> {
    return httpClient.delete<SessionDeleteResponse>(`/projects/${projectId}/sessions/${sessionId}`);
}

// Legacy default export for backwards compatibility during migration
const SessionService = {
    createSession,
    getUserSessions,
    findProjectIdBySessionId,
    getDefaultProjectIdFromSessions,
    getProjectSessions,
    getSessionDetail,
    updateSession,
    updateSessionStatus,
    deleteSession
};

export default SessionService;
